export function camelize(s: string, capitalize: boolean = false): string {
  const capitalized = s.replace(/(?:^|[-_])(\w)/g, function (stripped: string, letter: string): string {
    return letter ? letter.toUpperCase() : '';
  });
  if (capitalize) {
    return capitalized;
  }
  return capitalized.replace(/(^\w)/, function (letter: string): string {
    return letter.toLowerCase();
  });
}
